import React, {useState} from 'react';
import ReportProblemDialog from "../../../../dialogs/ReportProblemDialog";
import {useTranslation} from "react-i18next";
import {ReactComponent as AlertSvg} from "../../../../../assets/icons/alert.svg";
import {ReactComponent as ChevronRightSvg} from "../../../../../assets/icons/chevron-right.svg";
import {Tooltip} from "@mui/material";
import {StyledReportProblemWrapper, StyledReportProblemButton} from "./SidebarReportProblem.styled";

interface ReportProblemProps {
    isOpen: boolean;
}

const SidebarReportProblem = ({isOpen}: ReportProblemProps) => {
    const { t } = useTranslation();
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    return (
        <>
            <StyledReportProblemWrapper open={isOpen}>
                <Tooltip title={t('sidebar.goToReportProblem')}>
                    <StyledReportProblemButton
                        open={isOpen}
                        onClick={() => setIsDialogOpen(true)}
                    >
                        <AlertSvg />

                        {isOpen && <span>{t('sidebar.reportProblem')}</span>}
                        {isOpen && <ChevronRightSvg/>}
                    </StyledReportProblemButton>
                </Tooltip>
            </StyledReportProblemWrapper>

            <ReportProblemDialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)}/>
        </>
    );
};

export default SidebarReportProblem;